'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// Media query used to determine if the device is on a retina display
var RETINA_MEDIA = '(-webkit-min-device-pixel-ratio: 1.5),(-moz-min-device-pixel-ratio: 1.5),' + '(min-device-pixel-ratio: 1.5)';

var PLATFORMS = exports.PLATFORMS = {
    windows: 'windows',
    mac: 'mac',
    unix: 'unix',
    linux: 'linux',
    iOS: 'ios',
    android: 'android'
};

var getPlatform = exports.getPlatform = function getPlatform() {
    var _navigator = navigator,
        userAgent = _navigator.userAgent,
        appVersion = _navigator.appVersion;


    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) return PLATFORMS.iOS;
    if (userAgent.match(/Android/i)) return PLATFORMS.android;

    if (appVersion.indexOf('Win') !== -1) return PLATFORMS.windows;
    if (appVersion.indexOf('Mac') !== -1) return PLATFORMS.mac;
    if (appVersion.indexOf('X11') !== -1) return PLATFORMS.unix;
    if (appVersion.indexOf('Linux') !== -1) return PLATFORMS.linux;

    return null;
};

/**
 * Determines if the current device is retina or not.
 *
 * @return {Boolean} true if the current device is a retina display.
 */
var isRetina = exports.isRetina = window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(RETINA_MEDIA).matches;
var isTouch = exports.isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;
var isApple = exports.isApple = getPlatform() === PLATFORMS.mac || getPlatform() === PLATFORMS.iOS;
var isAndroid = exports.isAndroid = function isAndroid() {
    return getPlatform() === PLATFORMS.android;
};
var isMobile = exports.isMobile = function isMobile() {
    return getPlatform() === PLATFORMS.iOS || isAndroid();
};

var getUserAgent = function getUserAgent() {
    return window.navigator.userAgent || '';
};
var isBrowser = exports.isBrowser = function isBrowser(testRegex) {
    return testRegex.test(getUserAgent());
};
var isSafari = exports.isSafari = function isSafari() {
    return !!window.safari;
};
var isFirefox = exports.isFirefox = function isFirefox() {
    return isBrowser(/Firefox/g);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/utils/services/browser.js
// module id = 61
// module chunks = 0